import { TemplateElement, html, defineElement, when } from '@webtides/element-js';
import style from './content-cards.css';
import '../../../chip/chip.js';
import '../../../content-card/content-card.js';
import '../../../slider/slider.js';

/**
 * @typedef {Object} ContentCardProperties
 * @property {string} icon
 * @property {string} headline
 * @property {string} text
 * @property {string} [chipText]
 * @property {string} [chipVariant]
 */

/**
 * @property {string} headline
 * @property {ContentCardProperties[]} cards
 * @property {LinkProperties} link
 */
export default class ContentCards extends TemplateElement {
    constructor() {
        super({ styles: [style] });
    }

    properties() {
        return {
            headline: '',
            cards: [],
            link: undefined,
        };
    }

    template() {
        return html`
            <div class="flex flex-col gap-40">
                ${when(
                    this.headline,
                    html` <h2 class="text-2xl md:text-3xl mb-0 sm:text-center">${this.headline}</h2> `,
                )}
                <mb-slider>
                    ${this.cards.map(
                        (card, index) => html`
                            <div class="relative h-full" slot="slide-${index}">
                                ${when(
                                    card.chipText,
                                    html`
                                        <mb-chip
                                            variant="${card.chipVariant}"
                                            text="${card.chipText}"
                                            class="absolute right-24 top-16"
                                        ></mb-chip>
                                    `,
                                )}
                                <mb-content-card
                                    class="h-full"
                                    icon="${card.icon}"
                                    headline="${card.headline}"
                                    text="${card.text}"
                                ></mb-content-card>
                            </div>
                        `,
                    )}
                </mb-slider>
                ${when(
                    this.link?.url && this.link?.text,
                    html` <a href="${this.link?.url}" class="Button btn btn-outline-primary sm:self-center">
                        ${this.link?.text}
                    </a>`,
                )}
            </div>
        `;
    }
}

defineElement('mb-content-cards', ContentCards);
